import React from 'react';
import { Button, Modal } from 'reactstrap';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
// core components
export const SimpleModal = ({
  children,
  title = '',
  subtitle = '',
  showCloseButton = props.showCloseButton || true,
  modalContainerClasses = '',
  modalHeaderClasses = '',
  modalBodyClasses = '',
  centered = true,
  backdrop = true,
  isOpen,
  toggleModal,
  size,
  ...props
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <>
      <Modal
        backdrop={backdrop}
        className={modalContainerClasses}
        isOpen={isOpen}
        toggle={() => toggleModal()}
        centered={centered}
        size={size}
        {...props}
      >
        <div className={`modal-body ${modalBodyClasses}`}>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>×</span>
          </button>
          {children}

          {showCloseButton && (
            <div className="modal-footer">
              <Button
                style={buttonStyle(
                  systemConfiguration.cancelation_button_color
                )}
                className="ml-auto"
                data-dismiss="modal"
                type="button"
                onClick={() => toggleModal()}
              >
                Fechar
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
